import { useCallback, Dispatch, memo, useRef, useEffect } from 'react';
import { AutoCompleteResult } from './LocationBox.styles';
import { SuburbType } from './SuburbType';

interface Props {
  suburb: SuburbType;
  onChoose: Dispatch<SuburbType>;
  onHover: Dispatch<number>;
  isSelected: boolean;
  index: number;
}

export const LocationBoxSuggestion = memo((props: Props) => {
  const { suburb, onChoose: onClick, onHover, index, isSelected } = props;
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => onClick(suburb), [onClick, suburb]);
  const handleHover = useCallback(() => onHover(index), [index, onHover]);

  useEffect(() => {
    if (isSelected) ref.current?.scrollIntoView?.({ block: 'nearest' });
  }, [isSelected]);

  const { name, state, postcode } = suburb;

  return (
    <AutoCompleteResult
      ref={ref}
      onMouseDown={handleClick}
      onMouseEnter={handleHover}
      aria-selected={isSelected}
      aria-label={`${name}, ${state} ${postcode}`}
      data-testid="suburbAutoCompleteResult"
    >
      {name}, {state} {postcode}
    </AutoCompleteResult>
  );
});
